import React from "react";
import { Outlet } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import DownloadBanner from "@/components/DownloadBanner";
import InstallPWABanner from "@/components/InstallPWABanner";

export default function PublicLayout() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="relative min-h-screen bg-background">
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
        <DownloadBanner />
        <InstallPWABanner />
      </div>
    </ReactLenis>
  );
}
